import { call, put, takeLatest, select } from "redux-saga/effects";
import {
  deviceExplorerTypes,
  fetchDeviceExplorerGraphSuccess,
  fetchDeviceExplorerGraphFailure,
} from "../actions/deviceExplorer";
import { fetchDeviceEventExplorer } from "../../configuration";
import { getRandomUUID } from "../../Token";

const EMPTY_METRIC = {
  first: [], last: [], count: [], max: [], min: [],
  median: [], mean: [], sum: [], std_dev: [],
};

function buildEmptyMetric() {
  return Object.fromEntries(Object.keys(EMPTY_METRIC).map(k => [k, []]));
}

function* fetchDeviceExplorerGraphSaga() {
  try {
    const options = yield select((state) => ({
      currentId: state.deviceExplorer.currentId,
      startDateTime: state.deviceExplorer.startDateTime,
      endDateTime: state.deviceExplorer.endDateTime,
      resolution: state.deviceExplorer.resolution,
      seletedAttributes: state.deviceExplorer.seletedAttributes,
    }));

    const deviceInsightsResponse = yield call(
      fetchDeviceExplorerAPI,
      options.currentId,
      options.startDateTime,
      options.endDateTime,
      options.resolution,
      options.seletedAttributes,
    );

    const deviceInsightsArray = Object.entries(deviceInsightsResponse ?? {});
    const deviceInsights = {};

    if (Array.isArray(deviceInsightsArray)) {
      deviceInsightsArray.forEach(([key, metricData]) => {
        deviceInsights[key] = buildEmptyMetric();
        const dataPoints = Object.entries(metricData ?? {});
        dataPoints.forEach(([ts, stats]) => {
          deviceInsights[key].first.push([ts, stats.FIRST]);
          deviceInsights[key].last.push([ts, stats.LAST]);
          deviceInsights[key].count.push([ts, stats.COUNT]);
          deviceInsights[key].max.push([ts, stats.MAX]);
          deviceInsights[key].min.push([ts, stats.MIN]);
          deviceInsights[key].median.push([ts, stats.MEDIAN]);
          deviceInsights[key].mean.push([ts, stats.MEAN]);
          deviceInsights[key].sum.push([ts, stats.SUM]);
          deviceInsights[key].std_dev.push([ts, stats.STD_DEV]);
        });
      });
    }

    yield put(fetchDeviceExplorerGraphSuccess(deviceInsights));
  } catch (error) {
    console.log("error", error);
    yield put(fetchDeviceExplorerGraphFailure(error.message));
  }
}

async function fetchDeviceExplorerAPI(deviceId, startDateTime, endDateTime, resolution) {
  if (!startDateTime || !endDateTime) {
    throw new Error("startDateTime or endDateTime is missing");
  }
  const startDateTimeISO = new Date(startDateTime);
  const endDateTimeISO = new Date(endDateTime);

  const response = await fetch(fetchDeviceEventExplorer(), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      "VZ-M2M-Token": getRandomUUID(),
    },
    body: JSON.stringify({
      deviceid: deviceId,
      startDate: startDateTimeISO.toISOString(),
      endDate: endDateTimeISO.toISOString(),
      resolution: resolution,
    }),
  });

  if (!response.ok) return {};
  return response.json();
}

export function* DeviceExplorerGraphSaga() {
  yield takeLatest(
    deviceExplorerTypes.FETCH_DEVICE_EXPLORER_GRAPH_REQUEST,
    fetchDeviceExplorerGraphSaga
  );
}
